<template>
  <div>
    <v-row justify="space-between">
      <v-col class="align-self-center" v-if="tarefaSelecionada">
        <h3>
          {{ tarefaSelecionada.map + ' - ' + tarefaSelecionada.tarefa }}

          <button v-if="tarefaSelecionada.url_file_processo"
            class="btn-rounded-xs mdn-Button--global float-right"
            @click="abrirModalImage = true"
            v-b-tooltip.top
            title="Processo"
            data-bs-toggle="tooltip"
            >
            <i class="mdn-Icon-imagem" />
          </button>
        </h3>
      </v-col>
      <v-col md cols="4" class="align-self-center">
        <SGPFormBotaoComponent 
          color="primary" 
          class="float-right mr-2" 
          @click="voltarParaLista"
        >
          <v-icon small class="mr-2">mdi-arrow-left</v-icon>
          Voltar
        </SGPFormBotaoComponent>

        <SGPFormBotaoComponent color="error darken-1"  class="float-right mr-2" @click="abrirFiltroAvancado = !abrirFiltroAvancado">
          <v-icon small class="mr-2">mdi-filter</v-icon>
          Filtro Avançado
        </SGPFormBotaoComponent>
      </v-col>
    </v-row>

    <SGPFiltroAvancadoComponent 
      :abrirFiltroAvancado="abrirFiltroAvancado"
      :formSeletores="formSeletores"
      :filasTarefas="true"
      :filtroCec="true"
      :comCentroFuncional="ehModuloRecuperacao"
      @sgpFormFilterDadosClick="aplicarFiltro"
      @mudancaStatusEmit="mudancaStatusFiltro"
      @limparDadosEmit="limparFormFilter"
    />

    <SGPRowComponent>
      <SGPColComponent
        cols="12"
        class="text-right" 
        justify="center"
      >
        <SGPContadorRecarregamentoComponent
          :status="!loadingPcoTarefas"
          @sgpContadorRecarregamentoAtualizar="aplicarFiltro"
        ></SGPContadorRecarregamentoComponent>
      </SGPColComponent>
    </SGPRowComponent>

    <SGPRowComponent v-if="listagemWorkflows.length">
      <SGPColComponent cols="12" style="display: flex;">
        <div
          style="width: 25%; margin: 10px;"
          v-for="totalizador in totalizadoresWorkflows" 
          :key="totalizador.nome"
        >
          <SGPBoxHeaderInfoComponent
            cor="branco"
            larguraMaxima="120%"
            style="cursor: default;"
            :name="totalizador.nome"
            :value="totalizador.value"
            class="main-box"
          >
            <template v-slot:topLeft>
              <div class="text-right"></div>
            </template>
            <template v-slot:topCenter>
              <div class="text-center font-size-25">
                <span :class="'h1 main-title-pendente ' + ((totalizador.nome=='INTERROMPIDAS' && totalizador.value >= 1) ? 'text-danger' : '')">
                  {{ totalizador.value }}
                </span>
              </div>
            </template>
            <template v-slot:topRight>
              <div class="text-right">
                <span class="d-block font-size-14" style="text-align:right" v-if="totalizador.percentual != undefined">
                  {{ totalizador.percentual }}%
                </span>
              </div>
            </template>
            <template v-slot:contentCenter>
              <div class="text-center">
                <span class="main-title">{{ totalizador.nome }}</span>
              </div>
            </template>
          </SGPBoxHeaderInfoComponent>
        </div>
      </SGPColComponent>
    </SGPRowComponent>

    <SGPRowComponent v-if="listagemWorkflows.length">
      <SGPColComponent cols="12">
        <SGPPaginacaoComponent 
          :paginacao="paginacao" 
          @sgpAtualizarPaginacao="realizarPaginacao"
          :key="paginacao.current_page"
        >
          <SGPTabelaAvancadaComponent
            :key="versaoTabela"
            :filtroText="true"
            :colunas="colunasWorkflows"
            :dados="listagemWorkflows"
            aceitaHtml
            somenteLeitura
            :selecionarColunas="true"
          >
            <template v-slot:item.centro_funcional="{ item }">
              <CentroFuncionalBadge
                :valor="item.centro_funcional"
                :area-tecnica="item.area_tecnica"
              />
            </template>
            <template v-slot:item.descricao_problema_resumo="{ item }">
              <span :title="item.descricao_problema_completa || ''">
                {{ item.descricao_problema_resumo }}
              </span>
            </template>
          </SGPTabelaAvancadaComponent>
        </SGPPaginacaoComponent>
      </SGPColComponent>
    </SGPRowComponent>

    <SGPAlertaComponent v-else>
      Nenhum workflow encontrado para esta tarefa.
    </SGPAlertaComponent>

    <SGPModalImagemComponent
      v-if="abrirModalImage"
      :titulo="tarefaSelecionada.tarefa"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
      :url="tarefaSelecionada.url_file_processo"
    >
    </SGPModalImagemComponent> 

    <SGPLoadingComponent v-if="loadingPcoTarefas" />
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import moduleReload from '@/common/mixins/module-reload.js';
import { formatarOS } from '@/common/helpers/StringHelper';
import { CTRL_MODULOS } from '@/common/boot/Constantes';
import CentroFuncionalBadge from '@/common/sgp-components/CentroFuncionalBadge.vue';

export default {
  name: 'FilasTarefaDadosPage',

  mixins: [moduleReload],

  components: {
    CentroFuncionalBadge,
  },

  data() {
    return {
      ctrl_tarefa_id: null,
      abrirModalImage: false,
      abrirFiltroAvancado: false,
      formSeletores: {
        user_tratamento_id: '',
        interrompidos: '',
        projeto_migracao: '',
        disponibilizados: ''
      },
      filtro: {},
      porPagina: 100,
      versaoTabela: 0,
    };
  },

  async created() {
    this.ctrl_tarefa_id = parseInt(this.$route.params.ctrl_tarefa_id);
    this.filtro = this.filtrosDaRota();
    this.ocultarFiltrosDaBarra();

    this.$store.commit('filasTarefas/LISTAR_DADOS_WORKFLOWS', {});

    try {
      await this.recuperarTarefa({ id: this.ctrl_tarefa_id });
      await this.listarWorkflowsPorTarefa(this.montarParametrosFila());
    } catch (error) {
      if (error.response?.status === 403) {
        this.$router.push({ name: 'filas-tarefas' });
      }
    }
  },

  computed: {
    ...mapGetters('filasTarefas', [
      'listaDeWorkflowsPorTarefa',
      'tarefaSelecionada',
      'loadingPcoTarefas'
    ]),
    ...mapGetters('ctrlModulos', ['moduloAtivo']),

    ehModuloRecuperacao() {
      return this.moduloAtivo == CTRL_MODULOS.RECUPERACAO
    },

    listagemWorkflows() {
      const workflows = this.listaDeWorkflowsPorTarefa?.data || this.listaDeWorkflowsPorTarefa || [];

      return workflows.map(tarefa => {
        const workflow = tarefa.workflow || {};
        const provedorRecuperacao = workflow.provedor_recuperacao || {};
        const provedorInstalacao = workflow.provedor_instalacao || {};
        const _tipo = workflow.provedor_recuperacao ? 'recuperacao'
                    : workflow.provedor_instalacao  ? 'instalacao'
                    : 'outro';
        const provedor = provedorRecuperacao.provedor || provedorInstalacao.provedor || {};
        const designacao = provedorRecuperacao.designacao || {};
        const status = tarefa.status || {};
        const ctrlStatus = status.ctrl_status || {};

        return {
          ...tarefa,
          _tipo,
          // shared
          provedor_nome: provedor.nome || '-',
          responsavel_provedor: provedor.responsavel || '-',
          email_responsavel: provedor.email_responsavel || '-',
          telefone_responsavel: provedor.telefone_responsavel || '-',
          uf: designacao.uf_ponta_a || '-',
          cm: provedor.cm || '-',
          regional: _tipo === 'instalacao'
            ? (provedorInstalacao.ctrl_regional?.regional || '-')
            : (designacao.regional || '-'),
          cluster: provedor.cluster || '-',
          status_nome: ctrlStatus.status || '-',
          interrupcoes_count: tarefa.interrupcoes || 0,
          data_abertura: tarefa.created_at
            ? moment(tarefa.created_at).format('DD/MM/YYYY HH:mm')
            : '-',
          aging_dias_formatado: `${tarefa.aging_dias || 0} dias`,
          aging_dias_uteis_formatado: `${tarefa.aging_dias_uteis || 0} dias úteis`,
          data_finalizacao: tarefa.finalized_at
            ? moment(tarefa.finalized_at).format('DD/MM/YYYY HH:mm')
            : '-',
          ultima_atualizacao_tratativa: tarefa.ultimo_tratamento?.updated_at
            ? moment(tarefa.ultimo_tratamento.updated_at).format('DD/MM/YYYY HH:mm')
            : '-',
          dentro_sla_badge: workflow.dentro_sla,
          os_formatado: formatarOS(workflow.id),
          visualizar_aba: `/workflow/ficha-tecnica-tarefa/${tarefa.id}`,
          // recuperacao
          centro_funcional: provedorRecuperacao.centro_funcional || null,
          area_tecnica: provedorRecuperacao.area_tecnica || null,
          numero_rec: provedorRecuperacao.numero_rec || '-',
          cliente_final: provedorRecuperacao.cliente_final || '-',
          designacao_claro: designacao.designacao || '-',
          identificacao_acesso: provedorRecuperacao.identificacao_acesso_provedor || '-',
          descricao_problema: provedorRecuperacao.descricao_problema || '-',
          descricao_problema_resumo: this.formatarDescricaoProblema(provedorRecuperacao.descricao_problema),
          descricao_problema_completa: provedorRecuperacao.descricao_problema || '-',
          data_atendimento: provedorRecuperacao.data_atendimento_cliente
            ? moment(provedorRecuperacao.data_atendimento_cliente).format('DD/MM/YYYY HH:mm')
            : '-',
          data_agendamento: provedorRecuperacao.data_agendamento
            ? moment(provedorRecuperacao.data_agendamento).format('DD/MM/YYYY HH:mm')
            : '-',
          data_abertura_ticket: provedorRecuperacao.data_abertura_ticket
            ? moment(provedorRecuperacao.data_abertura_ticket).format('DD/MM/YYYY HH:mm')
            : '-',
          // instalacao
          tipo_servico: provedorInstalacao.tipo_servico?.nome || '-',
          tipo_solicitacao: provedorInstalacao.tipo_solicitacao?.nome || '-',
          cod_circuito: provedorInstalacao.cod_circuito || '-',
        };
      });
    },

    tiposWorkflows() {
      return new Set(this.listagemWorkflows.map(w => w._tipo));
    },

    totalizadoresWorkflows() {
      const workflows = this.listaDeWorkflowsPorTarefa?.data || this.listaDeWorkflowsPorTarefa || [];
      const total = this.listaDeWorkflowsPorTarefa?.total || workflows.length;
      
      const naoIniciadas = workflows.filter(t => 
        t.status?.ctrl_status?.status?.toLowerCase() === 'não iniciada'
      ).length;
      
      const emAndamento = workflows.filter(t => 
        t.status?.ctrl_status?.status?.toLowerCase() === 'em andamento'
      ).length;
      
      const interrompidas = workflows.filter(t => 
        t.status?.ctrl_status?.status?.toLowerCase() === 'interrompida'
      ).length;
      
      const foraSla = workflows.filter(w => !w.workflow?.dentro_sla).length;
      
      const percentualForaSla = total > 0 ? ((foraSla / total) * 100).toFixed(0) : 0;

      return [
        {
          nome: 'TOTAL',
          value: total,
          percentual: 100
        },
        {
          nome: 'NÃO INICIADAS',
          value: naoIniciadas,
          percentual: total > 0 ? ((naoIniciadas / total) * 100).toFixed(0) : 0
        },
        {
          nome: 'EM ANDAMENTO',
          value: emAndamento,
          percentual: total > 0 ? ((emAndamento / total) * 100).toFixed(0) : 0
        },
        {
          nome: 'INTERROMPIDAS',
          value: interrompidas,
          percentual: total > 0 ? ((interrompidas / total) * 100).toFixed(0) : 0
        },
        {
          nome: 'FORA DO SLA',
          value: foraSla,
          percentual: percentualForaSla
        }
      ];
    },

    paginacao() {
      if (!this.listaDeWorkflowsPorTarefa?.data) return {};
      
      const paginate = {
        per_page: this.listaDeWorkflowsPorTarefa.per_page,
        total: this.listaDeWorkflowsPorTarefa.total,
        current_page: this.listaDeWorkflowsPorTarefa.current_page
      };

      return {
        per_page: paginate.per_page >= paginate.total ? paginate.total : paginate.per_page,
        total: paginate.total,
        current_page: paginate.current_page
      };
    },

    colunasWorkflows() {
      const inicio = [
        { key: 'visualizar_aba',             label: 'Ficha Técnica',        sortable: false, width: 100, filterable: false },
        { key: 'provedor_nome',               label: 'Provedor',             sortable: true,  width: 200 },
        { key: 'os_formatado',               label: 'OS',                   sortable: true,  width: 130 },
      ]

      const colunasRecuperacaoInicio = [
        { key: 'numero_rec',          label: 'Número REC',          sortable: true, width: 150 },
        { key: 'centro_funcional',    label: 'CF',                  sortable: true, width: 140 },
      ]

      const base = [
        { key: 'status_nome',                 label: 'Status',               sortable: true,  width: 120 },
        { key: 'designacao_claro',            label: 'Designação',           sortable: true,  width: 150 },
        { key: 'responsavel_provedor',        label: 'Responsável',          sortable: true,  width: 150 },
        { key: 'uf',                          label: 'UF',                   sortable: true,  width: 80  },
        { key: 'regional',                    label: 'Regional',             sortable: true,  width: 150 },
        { key: 'aging_dias_formatado',        label: 'Aging (dias corridos)', sortable: true, width: 180 },
        { key: 'aging_dias_uteis_formatado',  label: 'Aging (dias úteis)',   sortable: true,  width: 180 },
        { key: 'data_finalizacao',            label: 'Data Finalização',     sortable: true,  width: 150 },
        { key: 'ultima_atualizacao_tratativa', label: 'Última Atualização',  sortable: true,  width: 170 },
        { key: 'dentro_sla_badge',            label: 'SLA',                  sortable: true,  width: 150 },
        { key: 'interrupcoes_count',          label: 'Interrupções',         sortable: true,  width: 120 },
      ];

      const colunasRecuperacao = [
        { key: 'cliente_final',       label: 'Cliente',             sortable: true, width: 200 },
        { key: 'identificacao_acesso',label: 'Identificação Acesso',sortable: true, width: 180 },
        { key: 'descricao_problema_resumo',  label: 'Descrição Problema',  sortable: true, width: 250 },
        { key: 'data_abertura_ticket',label: 'Data Abertura Ticket',sortable: true, width: 150 },
        { key: 'data_atendimento',    label: 'Data Atendimento',    sortable: true, width: 150 },
        { key: 'data_agendamento',    label: 'Data Agendamento',    sortable: true, width: 150 },
      ];

      const colunasInstalacao = [
        { key: 'tipo_solicitacao', label: 'Tipo Solicitação',  sortable: true, width: 150 },
        { key: 'tipo_servico',     label: 'Tipo de Serviço',   sortable: true, width: 150 },
        { key: 'cod_circuito',     label: 'Circuito',          sortable: true, width: 120 },
      ];

      const temRecuperacao = this.tiposWorkflows.has('recuperacao')
      const colunas = [
        ...inicio,
        ...(temRecuperacao ? colunasRecuperacaoInicio : []),
        ...base,
        ...(temRecuperacao ? colunasRecuperacao : []),
        ...(this.tiposWorkflows.has('instalacao')  ? colunasInstalacao  : []),
      ]

      if (!temRecuperacao) {
        return colunas.filter(coluna => coluna.key !== 'designacao_claro' && coluna.key !== 'uf')
      }

      return colunas
    },
  },

  methods: {
    ...mapActions('filasTarefas', [
      'recuperarTarefa',
      'listarWorkflowsPorTarefa'
    ]),

    reloadData() {
      this.$router.push({ name: 'filas-tarefas' });
    },

    voltarParaLista() {
      this.$router.push({ name: 'filas-tarefas' });
    },

    fecharModal() {
      this.abrirModalImage = false;
    },

    mudancaStatusFiltro(val) {
      this.abrirFiltroAvancado = val;
    },

    montarParametrosFila(extra = {}) {
      const { centro_funcional, ...filtro } = this.filtro || {}
      const seletores = Object.entries(this.formSeletores).reduce((acc, [chave, valor]) => {
        if (valor !== '' && valor != null) acc[chave] = valor
        return acc
      }, {})

      const params = {
        ctrl_tarefa_id: this.ctrl_tarefa_id,
        ...filtro,
        ...seletores,
        ...(centro_funcional ? { centro_funcional } : {}),
        per_page: this.porPagina,
        ...extra,
      }

      return Object.entries(params).reduce((acc, [chave, valor]) => {
        if (valor === '' || valor == null) return acc
        acc[chave] = valor
        return acc
      }, {})
    },

    filtrosDaRota() {
      const chaves = [
        'user_tratamento_id',
        'interrupcoes',
        'periodo',
        'ctrl_provedor_id',
        'centro_funcional',
        'uf_ponta_a',
        'regional_sigla',
        'ctrl_regional_id',
      ]
      const filtro = {}

      chaves.forEach((chave) => {
        const valor = this.$route.query[chave]
        if (valor == null || valor === '') return
        filtro[chave] = valor === 'true' ? true : valor
      })

      return filtro
    },

    ocultarFiltrosDaBarra() {
      if (!window.location.search) return
      window.history.replaceState(window.history.state, '', window.location.pathname)
    },

    async aplicarFiltro(dados) {
      if (dados) {
        this.filtro = dados
      }

      await this.listarWorkflowsPorTarefa(this.montarParametrosFila({ page: 1 }));
      this.abrirFiltroAvancado = false;
    },

    async realizarPaginacao(paginacao) {
      if (paginacao.per_page) this.porPagina = paginacao.per_page
      await this.listarWorkflowsPorTarefa(this.montarParametrosFila({
        page: paginacao.current_page,
        per_page: this.porPagina
      }));
    },

    async limparFormFilter() {
      this.formSeletores = {
        user_tratamento_id: '',
        interrompidos: '',
        projeto_migracao: '',
        disponibilizados: '',
      }
      this.filtro = {}
      await this.listarWorkflowsPorTarefa({
        ctrl_tarefa_id: this.ctrl_tarefa_id,
        page: 1,
        per_page: this.porPagina,
      })
      this.versaoTabela += 1
      this.abrirFiltroAvancado = false
    },

    formatarDescricaoProblema(descricao) {
      if (!descricao) {
        return '-';
      }

      const descricaoNormalizada = String(descricao).replace(/\s+/g, ' ').trim();
      const limite = 50;

      if (descricaoNormalizada.length <= limite) {
        return descricaoNormalizada;
      }

      return `${descricaoNormalizada.slice(0, limite)}...`;
    },
  },
};
</script>